import {config} from "config";
import * as React from "react";

export const SocialButtons = () => <div className={'social-buttons'}>
    <a href={`${config.apiUrl}/auth/social/facebook/`} style={{ backgroundImage: `url(${require('public/assets/images/icons/facebook.png')})` }}>Facebook</a>
    <a href={`${config.apiUrl}/auth/social/google/`} style={{ backgroundImage: `url(${require('public/assets/images/icons/google.png')})` }}>Google</a>
</div>;
